const f = {
  color: {
    background: "#f1f3f5ff",
    backgroundShine: "#f9fafaff"
  }
};
export {
  f as skeleton
};
